import React from 'react';

import RadioInputWithIcon from 'components/atoms/Input/RadioInputWithIcon';
import './index.scss';

const PcHowToDo = ({ value, checked, label, subLabel, point, icon, onChange, id }) => {

  return (
    <div className="PcHowToDo">
      <RadioInputWithIcon value={value} checked={checked} label={label} subLabel={subLabel} icon={icon} onChange={onChange} id={id} />
    </div>
  );
};

export default PcHowToDo;